import { Box, Typography } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { VF_ADMIN_ROLE_ID, toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import MonthlyExpenseTargetDialog from "../dialog/MonthlyExpenseTargetDialog";
import ContentLoader from "../loader/ContentLoader";
import { CustomTextField, getFinancialYearOptions } from "../../helpers/helper";
import styles from "./CreateExpenseTarget.module.css";
import { getAllExpenseTargets } from "../../reduxSlices/translationSlice";
import moment from "moment";
import NoResultFound from "../noResultFound/NoResultFound";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import history from "../../helpers/history";
import { getAllOrganisation } from "../../reduxSlices/organisationSlice";
import ButtonCta1 from "../button/ButtonCta1";
import { de } from "date-fns/locale";

const service = new Service();
const monthlyExpTargetArr = [
  { month: "January", expense: 0.0, target: 0.0 },
  { month: "February", expense: 0.0, target: 0.0 },
  { month: "March", expense: 0.0, target: 0.0 },
  { month: "April", expense: 0.0, target: 0.0 },
  { month: "May", expense: 0.0, target: 0.0 },
  { month: "June", expense: 0.0, target: 0.0 },
  { month: "July", expense: 0.0, target: 0.0 },
  { month: "August", expense: 0.0, target: 0.0 },
  { month: "September", expense: 0.0, target: 0.0 },
  { month: "October", expense: 0.0, target: 0.0 },
  { month: "November", expense: 0.0, target: 0.0 },
  { month: "December", expense: 0.0, target: 0.0 },
];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const reorderByMonthName = (arr, monthName) => {
  const startIndex = months.indexOf(monthName);
  if (startIndex === -1) return arr;

  return [...arr.slice(startIndex), ...arr.slice(0, startIndex)];
};

const CreateExpenseTarget = () => {
  const unblockRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [blockNavOpen, setBlockNavOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [loader, setLoader] = useState(false);
  const [block, setBlock] = useState(false);
  const [openMonthlyExpDialog, setOpenMonthlyExpDialog] = useState(false);
  const [openMonthlyExpConfirmDialog, setOpenMonthlyExpConfirmDialog] =
    useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [validYearExpTarget, setValidYearExpTarget] = useState(false);
  const [monthlyExp, setMonthlyExp] = useState(monthlyExpTargetArr);
  const [newYearlyExp, setNewYearlyExp] = useState({
    newTarget: "",
    newExpense: "",
  });
  const autoSaveYearlyRef = useRef(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [yearFormState, setYearFormState] = useState({
    organizationId: "",
    transalationId: "",
    transType: "opt1",
    translationValue: [
      {
        id: 0,
        outputId: 0,
        columnValue: "",
        customFieldCategory: "",
        min: "",
        max: "",
        startDate: "",
        endDate: "",
        error: "",
        yrerror: "",
      },
    ],
    isTranslationAdded: true,
  });

  useEffect(() => {
    console.log("yearFormState<<<<<", yearFormState);
  }, [yearFormState]);

  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const selectedOrg = localStorage.getItem("selectedOrg");
  const parseOrg = JSON.parse(selectedOrg);
  const organisationId = isVfAdmin
    ? parseOrg.organizationId
    : userData?.organisationId;
  const organisationName = isVfAdmin
    ? parseOrg.organizationName
    : userData?.organisationName;
  const transalationId = useSelector(
    (state) => state?.translation?.allExpenseTargets?.transalationId
  );
  const loading = useSelector((state) => state.translation.loading);
  const isTranslationAdded = useSelector(
    (state) => state?.translation?.isTranslationAdded
  );
  const allExpenseTargets = useSelector(
    (state) => state?.translation?.allExpenseTargets?.translationValue
  );
  const allOrganisation = useSelector(
    (state) => state.organization.allOrganisation
  );

  const filterOrg = allOrganisation?.find(
    (item) => item?.organizationId === organisationId
  );

  const monthName =
    typeof filterOrg?.financialYearStartMonth === "number"
      ? months[filterOrg.financialYearStartMonth - 1]
      : filterOrg?.financialYearStartMonth;
  const endMonthName = months[(months.indexOf(monthName) - 1 + 12) % 12];
  const yearOptions = React.useMemo(() => {
    if (!monthName) return [];
    return getFinancialYearOptions(monthName);
  }, [monthName]);

  useEffect(() => {
    if (!autoSaveYearlyRef.current) return;

    autoSaveYearlyRef.current = false;
    createTranslation();
  }, [yearFormState.translationValue]);

  useEffect(() => {
    if (!yearOptions.length) return;

    setSelectedYear((prev) => {
      if (!prev) return yearOptions[0];
      return prev;
    });
  }, [yearOptions]);

  useEffect(() => {
    const getOrganisationData = async () => {
      const obj = {
        searchText: "",
        organizationType: [],
        industry: [],
        package: [],
      };
      await dispatch(getAllOrganisation(obj));
    };
    getOrganisationData();
  }, [dispatch]);

  const handleChange = (e, data) => {
    const { name, value } = e.target;
    const modifiedData = yearFormState?.translationValue?.map((obj) => {
      if (obj.id === data.id) {
        if (
          (new Date(obj?.startDate).getFullYear().toString() ||
            new Date(obj?.endDate).getFullYear().toString()) !==
          selectedYear.value
        ) {
          if (isTranslationAdded) {
            dispatch(setUpdateButtonDisabled(false));
          } else {
            dispatch(setAddButtonDisabled(false));
          }
        } else {
          if (isTranslationAdded) {
            dispatch(setUpdateButtonDisabled(true));
          } else {
            dispatch(setAddButtonDisabled(true));
          }
        }
        if (name === "startDate") {
          if (new Date(value).getFullYear().toString() !== selectedYear.value) {
            return {
              ...obj,
              startDate: value,
              yrerror: "Date must be in the selected year range",
            };
          }
          return { ...obj, startDate: value, yrerror: "" };
        }
        if (name === "endDate") {
          if (new Date(value).getFullYear().toString() !== selectedYear.value) {
            return {
              ...obj,
              endDate: value,
              error: "Date must be in the selected year range",
            };
          }
          if (obj?.startDate && new Date(value) < new Date(obj.startDate)) {
            dispatch(setAddButtonDisabled(false));
            return {
              ...obj,
              endDate: value,
              error: "End date must be greater than start date",
            };
          }
          return { ...obj, endDate: value, error: "" };
        }
        return { ...obj, [name]: value };
      }
      return obj;
    });
    setYearFormState({
      ...yearFormState,
      translationValue: modifiedData,
    });
  };

  const getExpenseTargetsData = async () => {
    const obj = {
      organisationId: organisationId || "",
      year: selectedYear?.value || "",
      isFinancialYear: selectedYear?.isFinancialYear || false,
    };
    await dispatch(getAllExpenseTargets(obj));
  };

  useEffect(() => {
    if (!selectedYear) return;
    getExpenseTargetsData();
  }, [dispatch, selectedYear]);

  useEffect(() => {
    if (allExpenseTargets) {
      setYearFormState({
        ...yearFormState,
        organizationId: organisationId,
        transalationId: transalationId,
        translationValue: [...allExpenseTargets],
      });
    }
  }, [allExpenseTargets]);

  const handleInputFocus = () => {
    if (isTranslationAdded) {
      dispatch(setUpdateButtonDisabled(true));
    }
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "expense-target",
        title: "Expenses and Targets",
      })
    );
    dispatch(setAddButtonDisabled(false));
    dispatch(setUpdateButtonDisabled(false));
  }, []);

  useEffect(() => {
    if (buttonAction.page === "expense-target") {
      if (buttonAction.action === "add" || buttonAction.action === "update") {
        handleSubmit();
      }
      if (buttonAction.action === "cancel") {
        handleGoBack();
      }
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    createTranslation();
  };

  const createTranslation = async () => {
    setLoader(true);
    let url = `/api/Translations/AddExpenseTarget`;
    const user_token = localStorage.getItem("bb_access_token");
    const organisationData = prepareTranslationData();
    const formData = JSON.stringify(organisationData);
    try {
      let data = await service.newPostApi(url, formData, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success(`Your data has been recorded`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getExpenseTargetsData();
        dispatch(setUpdateButtonDisabled(false));
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const prepareTranslationData = () => {
    return { ...yearFormState };
  };

  const prepareData = prepareTranslationData();

  console.log("prepareTranslationData", prepareData);

  const getOptionLabel = (option) => {
    return option?.label;
  };

  const handleAutoCompleteChange = (item) => {
    if (item === null) {
      setYearFormState({
        ...yearFormState,
        translationValue: [],
      });
      setSelectedYear({ label: "", value: "" });
    } else {
      setSelectedYear(item);
    }
  };
  const handleAutoCompleteChangeMonthly = (item) => {
    setMonthlyExp(item);
  };
  const handleButtonClick = (action) => {
    setValidYearExpTarget(false);
    setSelectedProgram(action.columnValue);
    //get monhtly values for program
    getMonthlyExpTarget(action.columnValue);
    setOpenMonthlyExpDialog(true);
  };
  const getMonthlyExpTarget = async (program) => {
    setLoader(true);
    let url =
      `/api/Translations/GetMonthlyExpenseTargetTranslation?translationId=5&organizationId=` +
      organisationId +
      `&program=` +
      program +
      `&year=` +
      selectedYear?.value +
      "&isFinancialYear=" +
      selectedYear.isFinancialYear +
      "&financialYearStartMonth=" +
      (months.indexOf(monthName) + 1);
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.newGetApi(url, {}, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        let finalArr = [];
        if (resp?.data.length > 0) {
          var responseData = resp?.data.map((item) => ({
            month: item.month,
            expense: parseFloat(item.monthlyExpense ?? "0.0"),
            target: parseFloat(item.monthlyTarget ?? "0.0"),
          }));
          finalArr = responseData;
        } else {
          finalArr = reorderByMonthName([...monthlyExpTargetArr], monthName);
        }
        setMonthlyExp(finalArr);
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const addMonthlyExpTarget = async (monthlyexpReq) => {
    setLoader(true);
    let url = `/api/Translations/AddMonthlyExpenseTargetTranslation`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.newPostApi(url, monthlyexpReq, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        setOpenMonthlyExpDialog(false);
        toast.success("Translation has been updated successfully", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        setMonthlyExp(monthlyExpTargetArr);
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
        setOpenMonthlyExpDialog(false);
        setMonthlyExp(monthlyExpTargetArr);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
      setOpenMonthlyExpDialog(false);
      setMonthlyExp(monthlyExpTargetArr);
    }
  };

  useEffect(() => {
    if (block) {
      unblockRef.current = history.block((tx) => {
        let url = tx.location.pathname;
        setCurrentPath(url);
        setBlockNavOpen(true);
        return false;
      });
    }
    return () => {
      if (typeof unblock === "function") {
        unblockRef.current && unblockRef.current();
      }
    };
  }, [block]);

  function onCancel() {
    setBlockNavOpen(false);
  }

  function onConfirmNav() {
    if (unblockRef) {
      unblockRef.current();
    }
    setBlockNavOpen(false);
    history.push(currentPath);
  }

  const handleAddMonthlyExpConfirm = async () => {
    var val = yearFormState;
    var yearExpTargetValue = yearFormState.translationValue.filter(
      (e) => e.columnValue == selectedProgram
    )[0];
    const index = yearFormState.translationValue.findIndex(
      (e) => e.columnValue === selectedProgram
    );
    var validYearExpTar = validateYearlyTotals(monthlyExp, yearExpTargetValue);
    switch (validYearExpTar.action) {
      case 1:
        const updatedItem = {
          ...yearFormState.translationValue[index],
          min: validYearExpTar?.value?.annualTarget?.toString(),
          max: validYearExpTar?.value?.annualExpense?.toString(),
        };
        const updatedList = [...yearFormState.translationValue];
        updatedList[index] = updatedItem;
        autoSaveYearlyRef.current = true;
        setYearFormState({
          ...yearFormState,
          translationValue: updatedList,
        });
        if (!isTranslationAdded) {
          dispatch(setAddButtonDisabled(false));
        }
        break;
      case 2:
        setNewYearlyExp({
          newTarget: validYearExpTar?.value?.annualTarget?.toString(),
          newExpense: validYearExpTar?.value?.annualExpense?.toString(),
        });
        setOpenMonthlyExpConfirmDialog(true);
        return;
    }
    var monthlyexpReq = {
      monthlyExp: monthlyExp.map((e) => ({
        month: e.month,
        expense: e.expense.toString(),
        target: e.target.toString(),
      })),
      program: selectedProgram,
      organizationId: organisationId,
      year: selectedYear.value,
      isFinancialYear: selectedYear.isFinancialYear,
      financialYearStartMonth: months.indexOf(monthName) + 1,
    };
    setValidYearExpTarget(false);
    await addMonthlyExpTarget(monthlyexpReq);
  };

  const validateYearlyTotals = (monthlyExp, yearExpTargetValue) => {
    const totalTarget = monthlyExp.reduce(
      (sum, item) => sum + Number(item.target || 0),
      0
    );
    const totalExpense = monthlyExp.reduce(
      (sum, item) => sum + Number(item.expense || 0),
      0
    );

    const yearlyTarget = Number(yearExpTargetValue.min);
    const yearlyExpense = Number(yearExpTargetValue.max);

    if (
      (!yearlyTarget && totalTarget > 0) ||
      (!yearlyExpense && totalExpense > 0)
    )
      return {
        action: 1,
        value: { annualTarget: totalTarget, annualExpense: totalExpense },
      };
    else if (totalTarget !== yearlyTarget || totalExpense !== yearlyExpense)
      return {
        action: 2,
        value: { annualTarget: totalTarget, annualExpense: totalExpense },
      };
    else return 3;
  };

  const onCancelMonthlyExpConfirm = () => {
    setOpenMonthlyExpConfirmDialog(false);
    setOpenMonthlyExpDialog(false);
  };

  const onConfirmMonthlyExpConfirm = async () => {
    var newYearlyExpVal = newYearlyExp;
    var yearExpTargetValue = yearFormState.translationValue.filter(
      (e) => e.columnValue == selectedProgram
    )[0];
    const index = yearFormState.translationValue.findIndex(
      (e) => e.columnValue === selectedProgram
    );
    const updatedItem = {
      ...yearFormState.translationValue[index],
      min: newYearlyExpVal?.newTarget,
      max: newYearlyExpVal?.newExpense,
    };
    const updatedList = [...yearFormState.translationValue];
    updatedList[index] = updatedItem;
    autoSaveYearlyRef.current = true;

    setYearFormState({
      ...yearFormState,
      translationValue: updatedList,
    });
    if (!isTranslationAdded) {
      dispatch(setAddButtonDisabled(false));
    }
    const monthlyexpReq = {
      monthlyExp: monthlyExp.map((e) => ({
        month: e.month,
        expense: e.expense.toString(),
        target: e.target.toString(),
      })),
      program: selectedProgram,
      organizationId: organisationId,
      year: selectedYear.value,
      isFinancialYear: selectedYear.isFinancialYear,
      financialYearStartMonth: months.indexOf(monthName) + 1,
    };

    await addMonthlyExpTarget(monthlyexpReq);

    setOpenMonthlyExpDialog(false);
    setOpenMonthlyExpConfirmDialog(false);
  };

  if (loading || loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          width: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "left",
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: "Montserrat",
          color: "#5a5a5a",
          marginBottom: "10px",
        }}
      >
        <div>
          Please record the Targets and Expenses for your fundraising programs
          below. You can choose to enter values by month by selecting the “Add
          Monthly Targets & Expenses” button to input data, or you can enter the
          annual values only. If entering annual values only, monthly views in
          the report will divide the values evenly across all months.
        </div>
        <div style={{ marginTop: "10px" }}>
          {" "}
          {organisationName}'s financial year runs from {monthName} to{" "}
          {endMonthName}
        </div>
      </div>
      <div className={styles.yearDropdown}>
        <div
          style={{
            width: "30%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "16px",
            fontWeight: 600,
            fontFamily: "Montserrat",
            color: "#5a5a5a",
          }}
        >
          <label>Select Year</label>
          <div
            style={{
              width: "60%",
            }}
          >
            <CustomAutocomplete
              options={yearOptions}
              value={selectedYear}
              onChange={(e, value) => handleAutoCompleteChange(value)}
              getOptionLabel={(option) => option?.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value &&
                option.isFinancialYear === value.isFinancialYear
              }
              placeholder="Select Year"
            />
          </div>
        </div>
      </div>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "0 32px 32px 0",
          maxHeight: "calc(100vh - 240px)",
          overflowY: "auto",
        }}
        className="table_container"
      >
        <div className={styles.labelsDiv}>
          <div style={{ width: "340px", paddingBottom: "12px" }}>Program</div>
          {/* <div style={{ width: "206px", paddingBottom: "12px" }}>From</div>
          <div style={{ width: "206px", paddingBottom: "12px" }}>To</div> */}
          <div style={{ width: "300px", paddingBottom: "12px" }}>
            Annual Target
          </div>
          <div style={{ width: "300px", paddingBottom: "12px" }}>
            Annual Expenses
          </div>
          <div style={{ width: "280px", paddingBottom: "12px" }}></div>
        </div>
        {yearFormState?.translationValue?.length > 0 ? (
          <>
            {yearFormState?.translationValue &&
              yearFormState?.translationValue?.map((elem, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "60px",
                    marginTop: "10px",
                  }}
                >
                  <div className={styles.mainDiv}>
                    <div className={styles.childDiv}>
                      <div className={styles.container}>
                        <div className={styles.contentDiv}>
                          <div className={styles.acquisitonRetention1}>
                            {elem?.columnValue || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "206px",
                    }}
                  >
                    <CustomTextField
                      sx={{
                        width: "100%",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="date"
                      disabled
                      name="startDate"
                      value={moment(elem?.startDate || null).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) => handleChange(e, elem)}
                      onFocus={handleInputFocus}
                    />
                    {elem?.yrerror && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "14px",
                          fontWeight: 500,
                          fontFamily: "Montserrat",
                        }}
                      >
                        {elem?.yrerror}
                      </Typography>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "206px",
                    }}
                  >
                    <CustomTextField
                      sx={{
                        width: "100%",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="date"
                      disabled
                      name="endDate"
                      value={moment(elem?.endDate || null).format("YYYY-MM-DD")}
                      onChange={(e) => handleChange(e, elem)}
                      onFocus={handleInputFocus}
                    />
                    {elem?.error && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "14px",
                          fontWeight: 500,
                          fontFamily: "Montserrat",
                        }}
                      >
                        {elem?.error}
                      </Typography>
                    )}
                  </Box> */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "300px",
                    }}
                  >
                    <CustomTextField
                      placeholder="0.00"
                      sx={{
                        width: "100%",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="number"
                      name="min"
                      value={elem?.min || ""}
                      onChange={(e) => handleChange(e, elem)}
                      onFocus={handleInputFocus}
                      InputProps={{
                        startAdornment: (
                          <span style={{ marginRight: 5 }}>$</span>
                        ),
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "300px",
                    }}
                  >
                    <CustomTextField
                      placeholder="0.00"
                      sx={{
                        width: "100%",
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      type="number"
                      name="max"
                      value={elem?.max || ""}
                      onChange={(e) => handleChange(e, elem)}
                      onFocus={handleInputFocus}
                      InputProps={{
                        startAdornment: (
                          <span style={{ marginRight: 5 }}>$</span>
                        ),
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "280px",
                    }}
                  >
                    <ButtonCta1
                      text="Add Monthly Targets & Expenses"
                      onClick={() => handleButtonClick(elem)}
                      variant="contained"
                      disabled={false}
                      bgColor="#e0e0e0"
                      color="#5a5a5a"
                      width="280px"
                      height="48px"
                      sx={{ fontSize: "14px" }}
                    />
                  </Box>
                </Box>
              ))}
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 320px)",
            }}
          >
            <NoResultFound description="" />
          </div>
        )}
      </div>

      <CommonDialog
        open={blockNavOpen}
        setOpen={setBlockNavOpen}
        handleCancel={onCancel}
        handleDone={onConfirmNav}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
      <MonthlyExpenseTargetDialog
        open={openMonthlyExpDialog}
        onClose={() => setOpenMonthlyExpDialog(false)}
        onConfirm={handleAddMonthlyExpConfirm}
        monthlyExp={monthlyExp}
        selectedProgram={selectedProgram}
        validYearExpTargetMsg={validYearExpTarget}
        setMonthlyExp={(value) => handleAutoCompleteChangeMonthly(value)}
        handleInputFocus={handleInputFocus}
        leftButtonText="Cancel"
        rightButtonText="Update"
      />
      <CommonDialog
        open={openMonthlyExpConfirmDialog}
        setOpen={setOpenMonthlyExpConfirmDialog}
        handleCancel={onCancelMonthlyExpConfirm}
        handleDone={onConfirmMonthlyExpConfirm}
        title="The monthly value totals do not match the annual value entered"
        subTitle="Would you like to update the annual total?"
        leftButtonText="No"
        rightButtonText="Yes"
      />
    </>
  );
};

export default CreateExpenseTarget;
